<template>
  <div class="transition-global">
    <div class="totemBG tw-bg-cover tw-w-full tw-h-screen customGrid">
      <div class="tw-text-center">
        <vLogoDefault />
      </div>
      <div class="tw-flex tw-justify-center tw-items-center tw-w-full">
        <div
          v-if="isWarningNotItensAvailable"
          class="tw-z-10 tw-h-full tw-w-full tw-justify-center tw-items-center tw-flex tw-flex-wrap"
        >
          <div class="tw-bg-white tw-rounded tw-p-8">
            <div class="tw-text-center tw-text-2xl tw-p-5">
              Em manutenção no momento
            </div>
            <div class="tw-text-lg tw-text-center tw-text-gray-500">
              Você pode reiniciar a cabine para tentar novamente
            </div>
          </div>
        </div>
        <div
          v-else-if="tiposCarregados"
          :class="{ cardsQuatroOpcoes: getListaTipos.length > 3 }"
          class="cards-container tw-z-10 tw-h-full tw-w-full tw-justify-center tw-items-center tw-flex tw-flex-col tw-items-center"
        >
          <div
            class="cardItem tw-mx-auto tw-px-3 tw-py-1 tw-w-full tw-my-0 tw-cursor-pointer"
            v-for="(item, index) in getListaTipos"
            :key="index"
            :class="{
              [item.customCSS]: true,
              desativado: !item.ativo,
              option3x4: item.id === 'fotos_3x4' || item.id === 'passaporte',
            }"
            @click="selectType(item.id, item.ativo)"
          >
            <div
              v-if="!item.ativo"
              class="tw-p-2 tw-text-white tw-font-bold tw-text-xl tw-inline-block tw-absolute tw-rounded tw-border-4 tw-border-white"
            >
              Indisponível
            </div>
            <img
              draggable="false"
              @contextmenu.prevent
              @dragstart.prevent
              class="cardImagem"
              :src="item.imagem"
            />
            <div class="cardTexto tw-text-white tw-mt-4">
              <div class="cardTitulo tw-text-3xl tw-font-bold">
                {{ item.nome }}
              </div>
              <div class="cardSubtitulo tw-text-3xl tw-font-normal tw-mt-2">
                {{ item.descricao }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vFloatGuide destinoBack="CANCELADA" :next="false" />
    <vTimeout :segundos="$root.getTimeoutName('TIPO_FOTO')" />
    <ModalRegrasPassaporte
      v-if="mostrarRegrasPassaporte"
      @voltar="fecharRegrasPassaporte"
      @continuar="continuarPassaporte"
    />
  </div>
</template>

<script>
import etapa from "@/constants/etapaCompra";
import { getList, tiposDeFotos } from "@/constants/tipoFoto";
import { setCompra } from "@/service/firebase";
import anime from "animejs/lib/anime.es.js";
import vFloatGuide from "@/components/floatGuide.vue";
import ModalRegrasPassaporte from "@/components/ModalRegrasPassaporte.vue";
import posthog from "@/posthog";

export default {
  components: {
    vFloatGuide,
    ModalRegrasPassaporte,
  },
  data() {
    return {
      isWarningNotItensAvailable: false,
      listaDeTipos: [],
      // Regras do Itamaraty mostradas antes de seguir com o passaporte.
      mostrarRegrasPassaporte: false,
      // O editor aplica a obrigação de moldura do evento por formato; aqui os
      // formatos só dependem da impressora habilitada e da ocultação.
      tiposCarregados: false,
    };
  },
  beforeMount() {
    this.carregarListaTipos();
  },
  mounted() {
    this.animaMounted();
  },
  computed: {
    getListaTipos() {
      return this.listaDeTipos;
    },
    getTotem() {
      return this.$store.getters["totem/getTotem"];
    },
  },
  watch: {
    "getTotem.config": {
      deep: true,
      handler() {
        if (this.tiposCarregados) {
          this.tratamentoListaFotos();
        }
      },
    },
  },
  methods: {
    // Antes a lista esperava a leitura das molduras do evento
    // (personalizaTotem), cujo resultado não era usado: o editor relê o
    // documento. Agora a lista aparece na hora.
    carregarListaTipos() {
      this.tratamentoListaFotos();
      this.tiposCarregados = true;
    },
    markVerifyElement(item) {
      const cabineConfig = (this.getTotem || {}).config || {};
      if (item.id === "polaroid") {
        return cabineConfig.polaroid ? true : false;
      }
      if (item.id === "normal") {
        return cabineConfig.normal ? true : false;
      }
      if (item.id === "fotos_3x4") {
        return cabineConfig.fotos_3x4 ? true : false;
      }
      if (item.id === "passaporte") {
        return cabineConfig.passaporte ? true : false;
      }
      return false;
    },
    verificaItemOcultado(item) {
      const cabineConfig = (this.getTotem || {}).config || {};
      if (item.id === "polaroid") {
        return !!cabineConfig.ocultarPolaroid;
      }
      if (item.id === "normal") {
        return !!cabineConfig.ocultarNormal;
      }
      if (item.id === "fotos_3x4") {
        return !!cabineConfig.ocultar3x4;
      }
      if (item.id === "passaporte") {
        return !!cabineConfig.ocultarPassaporte;
      }
      return false;
    },
    tratamentoListaFotos() {
      // Recria a lista para recuperar formatos quando a ocultação for removida.
      this.listaDeTipos = getList()
        .filter((item) => !this.verificaItemOcultado(item))
        .map((item) => ({ ...item, ativo: !!this.markVerifyElement(item) }));
      // Formatos sem impressora habilitada continuam visíveis, mas indisponíveis.
      this.isWarningNotItensAvailable = !this.listaDeTipos.some(
        (element) => element.ativo
      );
      // Passaporte desligado ou oculto com o modal aberto: fecha o modal.
      if (!this.tipoDisponivel(tiposDeFotos.PASSAPORTE)) {
        this.mostrarRegrasPassaporte = false;
      }
    },
    animaMounted() {
      anime({
        targets: ".transition-global",
        opacity: {
          value: 1,
          delay: 0,
          duration: 1000,
          easing: "easeInOutExpo",
        },
      });
    },
    tipoDisponivel(tipo) {
      return (
        this.markVerifyElement({ id: tipo }) &&
        !this.verificaItemOcultado({ id: tipo })
      );
    },
    selectType(tipo, statusItem) {
      if (!statusItem || !this.tipoDisponivel(tipo)) {
        return;
      }
      if (tipo === tiposDeFotos.PASSAPORTE) {
        this.mostrarRegrasPassaporte = true;
        return;
      }
      this.iniciarCompra(tipo);
    },
    fecharRegrasPassaporte() {
      this.mostrarRegrasPassaporte = false;
    },
    continuarPassaporte() {
      // Evita seguir duas vezes com um toque duplo no botão.
      if (!this.mostrarRegrasPassaporte) {
        return;
      }
      this.mostrarRegrasPassaporte = false;
      // A configuração pode ter mudado enquanto o cliente lia as regras.
      if (this.tipoDisponivel(tiposDeFotos.PASSAPORTE)) {
        this.iniciarCompra(tiposDeFotos.PASSAPORTE);
      }
    },
    iniciarCompra(tipo) {
      posthog.capture("photo_type_selected", { photo_type: tipo });
      const compra = this.$store.getters["compra/getCompra"];
      const totemConfig = this.$store.getters["totem/getTotem"].config;
      compra.tipo_foto = tipo;
      compra.modo_captura = totemConfig.selfie ? null : "upload";
      compra.etapa = etapa.QTDE_FOTO;
      setCompra(compra);
    },
  },
};
</script>

<style lang="scss" scoped>
/* Grid principal: logo + área dos cards */
.customGrid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  min-height: 100vh;
}
.transition-global {
  opacity: 0;
}

/* Container dos cards: flex + gap com clamp; centralizado na tela */
.cards-container {
  gap: clamp(1rem, 3vh, 2.5rem);
  /* Sobe um pouco mais os cards na tela */
  margin-top: clamp(-6rem, -10vh, -3rem);
  width: 90%;
  max-width: 56.25rem; /* ~900px em base 16, evita cards largos demais em 4K */
  margin-left: auto;
  margin-right: auto;
}

/* Card: proporção consistente com clamp para min/max em diferentes resoluções */
.cardItem {
  box-shadow: 0 0.5rem 0.5rem rgba(140, 38, 101, 0.4);
  border-radius: 0.5rem;
  width: 100%;
  min-height: clamp(18rem, 22vh, 26rem);
  flex: 0 1 auto;
  image-rendering: optimizeQuality;
  text-rendering: optimizeLegibility;
  &.cardGradient1 {
    background: linear-gradient(180deg, #8876a1 0%, #222129 100%);
  }
  &.cardGradient2 {
    background: linear-gradient(180deg, #985d8f 0%, #1a191c 100%);
  }
  &.cardGradient3 {
    background: linear-gradient(180deg, #8876a1 0%, #1a191c 100%);
  }
  &.cardGradient4 {
    background: linear-gradient(180deg, #985d8f 0%, #222129 100%);
  }
  &.desativado {
    opacity: 0.5;
  }
  .cardImagem {
    width: clamp(12rem, 14vw, 16rem);
    image-rendering: optimizeQuality;
    @apply tw-mx-auto tw-block;
  }
  .cardDescricao {
    @apply tw-text-white;
  }
}
/* Com 4 tipos (passaporte ligado) tudo no card segue a altura da tela, para
   os 4 caberem acima do botão Voltar sem scroll também em telas mais baixas
   que 1080x1920 (zoom do Windows, monitor rotacionado). */
.cardsQuatroOpcoes {
  gap: clamp(0.5rem, 1.5vh, 1.5rem);
  /* Desconta a barra do Voltar (fixa, ~180px) ao centralizar os cards */
  padding-bottom: 180px;
  margin-top: 0;
  .cardItem {
    min-height: 0;
    padding-top: clamp(0.25rem, 1vh, 1rem);
    padding-bottom: clamp(0.25rem, 1vh, 1rem);
    .cardImagem {
      width: auto;
      height: clamp(3rem, 8vh, 10rem);
    }
    /* A arte do 3x4/passaporte não tem a borda transparente das outras:
       um pouco menor para os 4 cards ficarem equilibrados. */
    &.option3x4 .cardImagem {
      height: clamp(2.25rem, 6vh, 7.5rem);
    }
    .cardTexto {
      margin-top: clamp(0.25rem, 0.8vh, 0.75rem);
    }
    .cardTitulo,
    .cardSubtitulo {
      font-size: clamp(0.875rem, 1.6vh, 1.875rem);
      line-height: 1.25;
    }
    .cardSubtitulo {
      margin-top: 0.25rem;
    }
  }
}
.cardItem.option3x4 .cardImagem {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.totemBG {
  background-image: linear-gradient(
      180deg,
      #978fc4 0%,
      #a78ebd 34.84%,
      rgba(207, 138, 172, 0.8) 100%
    ),
    url("../../assets/fundo.png");
  background-size: cover;
}
</style>
